import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import NotFound from '../../pages/NotFound';

/**
 * NotFoundHandler Component
 *
 * Redirects to the Login page if the user is not authenticated.
 * Otherwise, it displays the "Not Found" page.
 * Safe when Redux store is not ready (e.g. PersistGate rehydration) or context is undefined.
 */
const NotFoundHandler = () => {
  let isAuthenticated = false;
  isAuthenticated = useSelector((state) => state?.auth?.isAuthenticated) ?? false;

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return <NotFound />;
};

export default NotFoundHandler;
